import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class MarketParityRoute extends Route {
  @service router;

  redirect(model, transition) {
    if (transition.targetName === 'market.parity.index') {
      this.router.transitionTo('market.parity.insight');
    }
  }
}
